import { Stack, Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

interface MeasurementDetectedModalProps {
    onContinue: () => void;
}

export function MeasurementDetectedModal({ onContinue }: MeasurementDetectedModalProps) {
    return (
        <BaseDialog
            onClose={onContinue}
            title={`📐 ${ts('measurement_detected', 'Measurement detected')}`}
            titleColor={theme.palette.primary.main}
            actionLabel={ts('continue_button_label', 'Continue')}
            onAction={onContinue}
        >
            <Stack spacing={0.5} sx={{ textAlign: 'center', mx: 'auto', maxWidth: 450 }}>
                <Typography>
                    {ts('measurement_detected_found', "We've found a measurement on your floor plan.")}
                </Typography>
                <Typography>
                    {ts('measurement_detected_review', 'Please review and confirm.')}
                </Typography>
                <Typography sx={{ pt: 2 }}>
                    {ts('measurement_detected_adjust', 'If needed, adjust the position or enter the correct measurement.')}
                </Typography>
            </Stack>
        </BaseDialog>
    );
}